export default __webpack_public_path__ + "static/media/Discover.5e47daa5.PNG";